export default {"src":"/_next/static/media/modern-entry-point.1a41ce71.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};